import { z } from 'zod';
import { applicationDateOrder, idArray, paymentReportsFilterSchema, transactionDateOrder } from './shared.schema';

const commonFields = z.strictObject({
	accountFilter: paymentReportsFilterSchema.optional(),
	areaIds: idArray.optional(),
	branchIds: idArray.optional(),
	districtIds: idArray.optional(),
	facilityIds: z.array(z.string()).optional(),
});

export const monthlyParkingPaymentParametersSchema = z.intersection(
	commonFields,
	z.discriminatedUnion('dateOrder', [transactionDateOrder, applicationDateOrder]),
);

export type MonthlyParkingPaymentParameters = z.infer<typeof monthlyParkingPaymentParametersSchema>;
